<script>
export default {
  props: ['item'],
  data() {
    return {
      loading: true,
    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    submit_form() {
      // console.log("submitted");
      this.$emit('setpage', 8);
    }
  }
}
</script>

<template>

  <div class="_w-m-1000 mx-auto my-5">
    <form @submit.prevent="submit_form()">
      <div class="title text-center mb-5">
        <img :src="formatImage('/fm/revinre-nc/clip art/Comparative market analysis.png')" class="" data-aos="fade-zoom-in">
        <h3 class="font-22 mb-3" data-aos="fade-zoom-in">Listing is live</h3>
        <p class="text-muted" data-aos="fade-zoom-in">Your listing is live! If at any point you need assistance or additional information on where to go from here please do not hesitate to reach out.</p>
        <p class="text-muted" data-aos="fade-zoom-in">If you would like to purchase upgrades please select the "Purchase upgrades" button above.</p>
      </div>

      <div class="row py-5">
        <div class="col-6">

        </div>
        <div class="col-6 text-right">

        </div>
      </div>
    </form>
  </div>

</template>
